import RectLoader from "../../../loaders/Rectangle";
import "./profileHeaderLoaderMobile.scss";

function ProfileHeaderLoaderMobile() {
	return (
		<div id="profile-header-loader-mobile" className="flex-column">
			<div className="banner-background">
				<RectLoader height={100} radius={0} width={200} />
			</div>
			<div className="flex-column profile-details">
				<div
					className="flex-row ai-fe jc-sb avatar-buttons"
					style={{ width: "100%" }}
				>
					<div className="profile-avatar">
						{/* <CircleLoader height={80} radius={50} width={80} /> */}
						<RectLoader height={80} radius={50} width={80} />
					</div>
					<div className="profile-buttons flex-row">
						<div
							style={{
								height: "33.17px",
								width: "56px",
								marginRight: "6px",
							}}
						>
							<RectLoader height={33.17} radius={19} width={56} />
						</div>
						<div style={{ height: "33.17px", width: "56px" }}>
							<RectLoader height={33.17} radius={19} width={56} />
						</div>
					</div>
				</div>
				<div className="flex-column profile-info ai-fs">
					<span className="profile-name">
						<RectLoader height={20} radius={4} width={200} />
					</span>
					<span className="profile-description">
						<RectLoader height={50} radius={4} width={200} />
					</span>
					<span className="profile-credential-count">
						<RectLoader height={20} radius={4} width={200} />
					</span>
				</div>
			</div>
		</div>
	);
}

export default ProfileHeaderLoaderMobile;
